let authConfig = null;
export const setAuthConfig = (config) => {
    if (!config.baseUrl || !config.retailerPartnerNumber) {
        throw new Error("AuthConfig is missing required values");
    }
    authConfig = config;
};
export const getAuthConfig = () => {
    if (!authConfig) {
        throw new Error("AuthConfig has not been set. Please call setAuthConfig in the main app");
    }
    return authConfig;
};
